import gql from 'graphql-tag';

const editOnboardingQueueRecordStatusMutation = gql`
  mutation EditOnboardingQueueRecordStatus($input: EditOnboardingQueueRecordStatusInput!) {
    editOnboardingQueueRecordStatus(input: $input) {
      success
      errors
      onboardingQueueRecord {
        flatRateOfferId
        status
        reason
        completedAt
        updatedAt
        updatedBy
      }
    }
  }
`;

export default editOnboardingQueueRecordStatusMutation;
